import { render, staticRenderFns } from "./ThemeSettingsDirectTopEasy.vue?vue&type=template&id=999750d2&scoped=true"
import script from "./ThemeSettingsDirectTopEasy.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTopEasy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999750d2",
  null
  
)

export default component.exports